import { useMemo } from 'react';

export function useClassName(
	...args: (string | boolean | null | undefined)[]
): string {
	return useMemo(() => args?.filter(Boolean).join(' ') || '', [...args]);
}
